import type { PropsWithChildren } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

import CompareModelsTableHeader from './CompareModelsTableHeader';
import type { CompareModelsTableHeaderVAlign } from './types';

export interface CompareModelsTableRowProps extends PropsWithChildren {
  readonly header: MessageKey;
  readonly headerAlign?: CompareModelsTableHeaderVAlign;
  readonly isLastRow?: boolean;
}

const CompareModelsTableRow = ({
  children,
  header,
  headerAlign = 'top',
  isLastRow = false,
}: CompareModelsTableRowProps) => {
  return (
    <div
      className="flex flex-wrap gap-x-10 gap-y-4 max-lg:border-b max-lg:border-gray-300 max-lg:last:border-b-0"
      role="row"
    >
      <CompareModelsTableHeader
        isLastRow={isLastRow}
        label={header}
        verticalAlign={headerAlign}
      />
      {children}
    </div>
  );
};

export default CompareModelsTableRow;
